import { useState } from "react";

// TODO: move hook in common place
export function usePopup() {
  const [popup, setPopup] = useState({
    addUser: false,
    addAdminUser: false,
    bulkUsersCreation: false,
    edit: false,
    delete: false,
    reactivate: false,
    duplicate: false,
    mirror: false,
    loginAs: false,
    setAdmin: false
  });

  const openPopup = (type) => {
    setPopup((prev) => ({ ...prev, [type]: true }));
  };

  const closePopup = (type) => {
    return () => setPopup((prev) => ({ ...prev, [type]: false }));
  };

  return { popup, openPopup, closePopup };
}
